module.exports = __webpack_public_path__ + "img/cute_handdrawn_5.7bc95ac2.png";